// @flow

import * as React from 'react';
import { isEmpty } from 'utils/functional';
import { isUrlWithProtocol } from 'utils/url';
import { PrimaryButtonRouterLink, PrimaryButtonLink } from 'components/Button';
import Icon from 'components/Icon';
import Box from 'components/Box';
import type { StickyHeaderLinksBlockData } from 'api/cms';
import StickyHeaderLinks from './StickyHeaderLinks';

const ExternalLink = ({
  href,
  children
}: {
  href: string,
  children: ?React.Node
}) => (
  <PrimaryButtonLink href={href} target="_blank">
    {children}
    <Box transform="translateY(1px)" display="inline-block" ml="6px">
      <Icon name="external-link" width={12} stroke="currentColor" />
    </Box>
  </PrimaryButtonLink>
);

const StickyHeaderLinksBlock = ({
  data: { links, buttonText, buttonUrl }
}: {
  data: StickyHeaderLinksBlockData
}) => {
  const hasButton = !isEmpty(buttonUrl) && !isEmpty(buttonText);
  return (
    <StickyHeaderLinks
      links={links}
      button={
        hasButton &&
        (buttonUrl && isUrlWithProtocol(buttonUrl) ? (
          <ExternalLink href={buttonUrl}>{buttonText}</ExternalLink>
        ) : (
          <PrimaryButtonRouterLink to={buttonUrl}>
            {buttonText}
          </PrimaryButtonRouterLink>
        ))
      }
    />
  );
};

export default StickyHeaderLinksBlock;
